import { render, staticRenderFns } from "./FormsContainer.vue?vue&type=template&id=28f4f11d&scoped=true"
import script from "./FormsContainer.vue?vue&type=script&lang=js"
export * from "./FormsContainer.vue?vue&type=script&lang=js"
import style0 from "./FormsContainer.vue?vue&type=style&index=0&id=28f4f11d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f4f11d",
  null
  
)

export default component.exports